import React from 'react';

import { ActionButtonSizes } from 'components/action-button';
import { useLocationContext } from 'state/location';
import { CustomEventNames, EventTypes, useMParticleContext } from 'state/mParticle';
import { routes } from 'utils/routing';

import { StyledButton, StyledMyCodeIcon } from './styled';

export const MyCodeButton = () => {
  const { navigate, location } = useLocationContext();
  const mParticle = useMParticleContext();

  return (
    <StyledButton
      data-testid="my-code-header-button"
      onClick={() => {
        mParticle.trackEvent({
          name: CustomEventNames.BUTTON_CLICK,
          type: EventTypes.Navigation,
          attributes: {
            Name: 'My Code Header',
          },
        });
        navigate(routes.redeem, {
          state: {
            backRoute: location.pathname,
          },
        });
      }}
      size={ActionButtonSizes.SMALL}
    >
      <StyledMyCodeIcon />
    </StyledButton>
  );
};
